import { useEffect, useRef, useState } from 'react';
import { trackEvent } from '../utils/analytics';

const KITTEN_EMOJIS = ['🐱', '🐈', '😺', '🐈‍⬛', '😸', '🐾'];

/**
 * The verdict emoji. On a day for it, the sun is a button that releases a burst of kittens.
 */
function VerdictGraphic({ isDayForIt }) {
  const [kittenBursts, setKittenBursts] = useState([]);
  const kittenTimeoutsRef = useRef([]);
  const kittenBurstIdRef = useRef(0);

  useEffect(() => () => {
    kittenTimeoutsRef.current.forEach((timeoutId) => window.clearTimeout(timeoutId));
  }, []);

  const handleSunClick = () => {
    const burstId = kittenBurstIdRef.current;
    kittenBurstIdRef.current += 1;

    const kittens = Array.from({ length: 6 }, (_, index) => {
      const spread = index - 2.5;

      return {
        id: `${burstId}-${index}`,
        emoji: KITTEN_EMOJIS[(burstId + index) % KITTEN_EMOJIS.length],
        style: {
          '--kitten-x': `${spread * 34}px`,
          '--kitten-y': `${-88 - Math.abs(spread) * 20 - (burstId % 3) * 8}px`,
          '--kitten-rotate': `${spread * 18}deg`,
          '--kitten-delay': `${index * 0.04}s`,
          '--kitten-scale': `${0.9 + (index % 3) * 0.12}`,
        },
      };
    });

    const kittenIds = new Set(kittens.map((kitten) => kitten.id));
    setKittenBursts((currentBursts) => [...currentBursts, ...kittens]);
    trackEvent('kitten_easter_egg_click', { burst_size: kittens.length });

    const timeoutId = window.setTimeout(() => {
      setKittenBursts((currentBursts) =>
        currentBursts.filter((kitten) => !kittenIds.has(kitten.id))
      );
      kittenTimeoutsRef.current = kittenTimeoutsRef.current.filter((id) => id !== timeoutId);
    }, 1600);

    kittenTimeoutsRef.current.push(timeoutId);
  };

  if (!isDayForIt) {
    return <div className="graphic">🌧️🍺</div>;
  }

  return (
    <div className="graphic graphic--interactive">
      <button
        type="button"
        className="sun-burst-button"
        onClick={handleSunClick}
        aria-label="Release kittens from the sun"
      >
        <span className="sun-burst-emoji" aria-hidden="true">☀️</span>
      </button>
      <span className="graphic-drink" aria-hidden="true">🍻</span>
      <span className="kitten-burst-layer" aria-hidden="true">
        {kittenBursts.map((kitten) => (
          <span
            key={kitten.id}
            className="kitten-burst"
            style={kitten.style}
          >
            {kitten.emoji}
          </span>
        ))}
      </span>
    </div>
  );
}

export default VerdictGraphic;
